var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNALR_URL = void 0;
const convertToContextUri_1 = __importDefault(require("@hendersonengineers/utils/convertToContextUri"));
exports.SIGNALR_URL = (0, convertToContextUri_1.default)('https://signalr.hendersonengineers.com');
//# sourceMappingURL=constants.js.map